module.exports = __webpack_public_path__ + "img/1541359463.0a83ce66.jpg";